import React, { useEffect } from 'react'
import AppRoutes from './AppRoutes'
import { useDispatch } from 'react-redux'
import { initializeFirebase, auth, signInWithCustomToken } from '../firebase/config'
import { useKeycloak } from '@react-keycloak/web'
import { Loader } from 'rsuite'
import { userTokenFromKc } from '../misc/utils/user'
import { envSelector, setUser } from '../features/environment/environmentSlice'
import { useAuthStateUpdate } from '../auth/useAuthStateUpdate'
import { useAppSelector } from './hooks'
import { createAxios } from '../auth'
import { IRIS_BASE_URL } from '../api'
import { useNativeBridge } from './useNativeBridge'
import './App.css'
import 'rsuite/dist/rsuite.min.css'


export const App: React.FC = () => {
  // Initialize the firebase app.
  initializeFirebase()
  const { initialized, keycloak } = useKeycloak()
  const { user } = useAppSelector(envSelector)

  const dispatch = useDispatch()

  useAuthStateUpdate()
  // Native (RN WebView) bridge for incoming-call push — no-op in a normal browser.
  useNativeBridge()

  // The App component listens continuously for changes in the auth context
  // and updates the auth status accordingly
  useEffect(() => {
    if (initialized && keycloak && keycloak.token) {
      let user = userTokenFromKc(keycloak)
      dispatch(setUser(user))

      createAxios(keycloak.token)
        .get(`${IRIS_BASE_URL}/firebase/token`)
        .then(resp => signInWithCustomToken(auth, resp.data.token))
        .catch(err => console.error('Firebase sign-in failed', err))
    }

  }, [dispatch, initialized, keycloak])

  if (!user) {
    return (<Loader content="Loading..." center size="md"/>)
  }

  return (
    <AppRoutes/>
  )
}
